import Image from "next/legacy/image";
import React, { forwardRef } from "react";
import { useContext } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import AmenityMobile from "../common/AmenityMobile";
import Promise from "../common/Promise";
import FadeIn from "../Animations/FadeIn";
import { useInView } from "react-intersection-observer";
import { useState } from "react";
// eslint-disable-next-line react/display-name
const OurPromises = forwardRef(({ dataList, header }, ref) => {
	const { isMobile } = useContext(isMobileContext);
	const [active, setActive] = useState(0)
	const { locale } = useRouter();
	const [slideNumber, setSlideNumber] = useState(1)
	let [amenityRef, inView] = useInView({ threshold: 1, triggerOnce: true })

	return (
		<div className={`amenities-section promises-section our-promise`} id="our-promise" ref={ref}>
			<div ref={amenityRef}></div>
			<FadeIn customClass="header">
				<h2 className="light _eleX">{header}</h2>
			</FadeIn>
			{!isMobile ? (
				<div className="amenities-container promises-container">
					{dataList?.map((promise, index) => (
						<Promise promise={promise} key={index} index={index} />
					))}
				</div>
			) : (
				<div className={`amenities-swiper-mobile promises-swiper ${inView ? "in-view" : ""}`}>
					<Swiper
						key={dataList?.length}
						style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
						modules={[Navigation, Pagination]}
						navigation={{
							nextEl: ".swiper-button-next-amenities",
							prevEl: ".swiper-button-prev-amenities",
						}}
						slidesPerView={1}
						spaceBetween={40}
						breakpoints={{
							768: {
								slidesPerView: 1.5,
								spaceBetween: 20,
							},
							1023: {
								slidesPerView: 2.5,
								spaceBetween: 20,
							},
						}}
						onSlideChange={(swiper) => { setActive(swiper.activeIndex), setSlideNumber(1 + slideNumber) }}
						pagination={{
							type: "progressbar",
							el: ".swiper-promise-navigation",
						}}
					>
						{dataList?.map((promise, index) => (
							<SwiperSlide key={index}>
								<Promise promise={promise} key={index} index={index} active={active} />
							</SwiperSlide>
						))}
						<div className={`swiper-navigation-continer ${dataList?.length == 1 ? "d-none" : ""}`}>
							<div className='navigation-container'>
								<div className='slide-number-container bold'>
									<div>{slideNumber.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
									<div>{dataList?.length.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
								</div>
								<div className='swiper-promise-navigation swiper-pagination-progressbar'></div>
							</div>
							<div className="arrows-container">
								<div className="swiper-button-prev swiper-button-prev-amenities amenities-arrow black-arrow-prev"></div>
								<div className="swiper-button-next swiper-button-next-amenities  amenities-arrow black-arrow-next"></div>
							</div>
						</div>
					</Swiper>
				</div>
			)}
		</div>
	)
}
)

export default OurPromises